import React from 'react';
import Lookup from '../componentes/select2';
import { autobind } from 'core-decorators';

@autobind
class StatusReuniao extends React.Component {
  render() {
    return <Lookup labelKey="descricao" valueKey="id" url="/StatusReuniaoLookup" {...this.props} />;
  }
}

export default StatusReuniao;
